import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import withAll from 'components/base/withAll';
import { connect } from 'react-redux';
import { get, orderBy } from 'lodash';
import { ALL_LABEL } from 'components/common/CompetitiveReport/constants';
import PlatformDistribution from './PlatformDistribution';

const styles = () => ({
  root: {},
});

const filterBrands = data => orderBy(data.filter(d => d.label !== ALL_LABEL), 'label');

const PlatformDistributionByBrand = ({
  postsByPlatform,
  classes,
  labels,
}) => (
  <div className={classes.root}>
    <Grid container spacing={2} justifyContent="center">
      {postsByPlatform.map(d => (
        <Grid item md={3}>
          <PlatformDistribution
            title={d.label}
            data={{
              values: d.values,
              labels,
            }}
          />
        </Grid>
      ))}
    </Grid>
  </div>
);

PlatformDistributionByBrand.propTypes = {
  postsByPlatform: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

const mapStateToProps = ({ competitiveReportDistribution }) => ({
  postsByPlatform: filterBrands(get(competitiveReportDistribution, 'data.postsByPlatform.dataSets', [])),
  labels: get(competitiveReportDistribution, 'data.postsByPlatform.labels', []),
});

export default withAll(
  connect(mapStateToProps, null),
  withStyles(styles),
)(PlatformDistributionByBrand);
